export default "__VITE_ASSET__5oEIuEBP__"